import PropTypes from 'prop-types';
import { useMemo } from 'react';
import Heading from '../Heading/Heading';
import BoardItem from '../BoardItem/BoardItem';
import { Icon } from '../common/Icons';
import Wrapper from '../common/Wrapper/Wrapper';
import { StyledBoardsContainer, StyledContainer } from './Boards.styles';

function Boards({ data }) {
  if (!Object.entries(data).length) return null;

  const BoardIcon = useMemo(() => (data.heading.icon === 'dashboard' ? <Icon.Dashboard /> : null));

  return (
    <StyledContainer>
      <Wrapper>
        {data.heading && <Heading title={data.heading.title} icon={BoardIcon} />}
        <StyledBoardsContainer>
          {data.boards && data.boards.map(board => <BoardItem data={board} key={board.id} />)}
        </StyledBoardsContainer>
      </Wrapper>
    </StyledContainer>
  );
}

Boards.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.shape({
      title: PropTypes.string,
      icon: PropTypes.string,
    }),
    boards: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        image: PropTypes.string,
        itemCount: PropTypes.string,
        title: PropTypes.string,
      })
    ),
  }),
};

Boards.defaultProps = {
  data: {},
};

export default Boards;
